import { gql } from "@apollo/client";

export const MODIFIER_FIELDS_FRAGMENT = gql`
  fragment ModifierFields on Modifier {
    id
    name
    price
    accountId
    groupId
    isDefault
    isMultiple
  }
`;

export const GET_MODIFIER = gql`
  ${MODIFIER_FIELDS_FRAGMENT}
  query Modifier($input: ModifierInput!) {
    modifier(input: $input) {
      ...ModifierFields
    }
  }
`;

export const GET_MODIFIERS = gql`
  ${MODIFIER_FIELDS_FRAGMENT}
  query Modifiers($input: ModifiersInput!) {
    modifiers(input: $input) {
      ...ModifierFields
    }
  }
`;

export const CREATE_MODIFIER = gql`
  ${MODIFIER_FIELDS_FRAGMENT}
  mutation ModifierCreate($input: ModifierCreateInput!) {
    modifierCreate(input: $input) {
      ...ModifierFields
    }
  }
`;

export const UPDATE_MODIFIER = gql`
  ${MODIFIER_FIELDS_FRAGMENT}
  mutation ModifierUpdate($input: ModifierUpdateInput!) {
    modifierUpdate(input: $input) {
      ...ModifierFields
    }
  }
`;

export const DELETE_MODIFIER = gql`
  mutation ModifierDelete($input: ModifierDeleteInput!) {
    modifierDelete(input: $input)
  }
`;

export const GET_MODIFIER_GROUP = gql`
  query ModifierGroup($input: ModifierGroupInput!) {
    modifierGroup(input: $input)
  }
`;

export const UPDATE_MODIFIER_GROUP = gql`
  mutation ModifierGroupUpdate($input: ModifierGroupUpdateInput!) {
    modifierGroupUpdate(input: $input)
  }
`;
